import ControlButton from "components/common/control-button";
import Icons from "components/icons";
import { BookmarksContext } from "context/bookmarks";
import React, { memo, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import FullScreenButton from 'components/full-screen-components/full-screen-button';
import MoreMenuButton from 'components/full-screen-components/more-menu-button';
import { connect } from "react-redux";
import { ebookDataPropType, queuePropType } from "utils/prop-types";
import SettingsMenu from './settings-menu';
import NavigationMenu from './navigation-menu';
import useStyles from './control-panel.styles';
import SearchMenu from './search-menu';

const ControlPanel = memo((props) => {
  const { pdf, queue, activeIndex, ebookData } = props;
  const { assetId } = queue[activeIndex] ?? {};
  const { currentPage, totalPages } = ebookData;
  const classes = useStyles();

  const { toggleBookmark, isBookmarkActive } = useContext(BookmarksContext);

  const onBookmarkClick = useCallback(() => {
      const location = {
          locations: {
              position: currentPage,
              totalProgression: totalPages && (currentPage / totalPages) || 0
          }
      };
    toggleBookmark(assetId, location);
  }, [assetId, currentPage, toggleBookmark]);

  const getBookmarkIcon = useCallback(() => {
      const location = { locations: { position: currentPage } };
      return isBookmarkActive(location) ?
          Icons.ReaderBookmarkRemove :
          Icons.ReaderBookmark;
  }, [isBookmarkActive, currentPage]);

  return (
    <Box className={classes.controlPanelContainer}>
      <SearchMenu
        pdf={pdf}
        controlBtnProps={{
          className: classes.controlButton,
          iconClassName: classes.controlIcon,
        }}
      />
      <FullScreenButton className={classes.controlButton} iconClassName={classes.controlIcon} />
      <ControlButton
        onClick={onBookmarkClick}
        className={classes.controlButton}
        iconClassName={classes.controlIcon}
        icon={getBookmarkIcon()}
      />
      <SettingsMenu
        controlBtnProps={{
          className: classes.controlButton,
          iconClassName: classes.controlIcon,
        }}
      />
      <NavigationMenu
        pdf={pdf}
        controlBtnProps={{
          className: classes.controlButton,
          iconClassName: classes.controlIcon,
        }}
      />
      <MoreMenuButton
        className={classes.moreMenu}
        itemClassName={classes.moreMenuItem}
        textClassName={classes.moreMenuText}
        controlBtnProps={{
          className: classes.controlButton,
          iconClassName: classes.controlIcon,
        }}
      />
    </Box>
  );
});

ControlPanel.propTypes = {
  pdf: PropTypes.shape({}),
  queue: queuePropType,
  ebookData: ebookDataPropType,
  activeIndex: PropTypes.number,
};

const mapStateToProps = ({ player }) => ({
  queue: player.queue,
  ebookData: player.ebookData,
  activeIndex: player.activeIndex,
});

export default connect(mapStateToProps)(ControlPanel);
